import { render, staticRenderFns } from "./SingleChoiceQuestion.vue?vue&type=template&id=ef5b0d9c&"
import script from "./SingleChoiceQuestion.vue?vue&type=script&lang=js&"
export * from "./SingleChoiceQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports